import script from "./detail-img.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-img.vue?vue&type=script&setup=true&lang=js"

import "./detail-img.vue?vue&type=style&index=0&id=6b824bbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b824bbb"]])

export default __exports__